import { TradeIn } from '@upstart/harmony/lib/legos/dealTypes';

export const isUpdatingExistingTradeIns = (
  tradeIns: TradeIn[],
  newTradeIns: TradeIn[],
): boolean =>
  tradeIns.some(
    (tradeIn, index) =>
      tradeIn.id !== newTradeIns[index]?.id ||
      tradeIn.year?.name !== newTradeIns[index]?.year?.name ||
      tradeIn.make?.name !== newTradeIns[index]?.make?.name ||
      tradeIn.model?.name !== newTradeIns[index]?.model?.name ||
      tradeIn.trim?.name !== newTradeIns[index]?.trim?.name ||
      tradeIn.mileage !== newTradeIns[index]?.mileage ||
      tradeIn.tradeValue !== newTradeIns[index]?.tradeValue ||
      tradeIn.payOff !== newTradeIns[index]?.payOff,
  );
